import axios from 'axios';
const { handleOAuthFlow } = require('./oauth_flow');

const nexum_sym = process.env.REACT_APP_NEXUM_SYM;
const nexum_api_key = process.env.REACT_APP_NEXUM_API_KEY;
const nexum_dev_endpoint = process.env.REACT_APP_NEXUM_DEV_ENDPOINT;
const nexum_ac = process.env.REACT_APP_NEXUM_AC;
const key = process.env.REACT_APP_USPSAPI_KEY;

//don't forget to add your nexum environmental variables here
const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT;
const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

// Temporary debug log
const getMemberInfo = async () => {
  const timeout = 5000;
 
  // Check for existing authentication
  const existingAuth = sessionStorage.getItem('auth_data');
  if (existingAuth) {
    try {
      const authData = JSON.parse(existingAuth);
      // Check if the auth data is still valid (you might want to add expiration check here)
      return authData;
    } catch (e) {
      sessionStorage.removeItem('auth_data');
    }
  }
 
  // Get query parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
 
  try {
    // Validate required parameters
    if (!plugin_client_id || !plugin_client_secret || !plugin_environment) {
        throw new Error('Missing required parameters');
    }
 
    // Create a promise that rejects after timeout
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(`Request timed out after ${timeout}ms`));
        }, timeout);
    });
 
    const req = {
      code: code,
      state: state
    }
 
    const requestPromise = handleOAuthFlow({
      plugin_environment,
      plugin_client_id,
      plugin_client_secret,
      plugin_redirecturi,
      req
    });
 
    // Race between the timeout and the actual request
    const result = await Promise.race([requestPromise, timeoutPromise]);
   
    if (result) {
      if (result.results === 'OK'){
        // Store the successful authentication data
        sessionStorage.setItem('auth_data', JSON.stringify(result));
        return result;
      } else if (result.results === 'ERROR'){
          throw new Error(result.error);
      } else {
          // Store state and code_verifier in sessionStorage
          sessionStorage.setItem(`STATE_${result.state}`, result.code_verifier);
          // Redirect to the authorization URL
          window.location.href = result.redirect_url;
          return null;        
      }
    }
  } catch(error) {
      return {
          results: "ERROR",
          error: error.message,
          member_number: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          user_type: "",
          user_name: "",
          phone_number: ""
      };
  }
};

const config = {
  headers: {
    'Authorization': `Bearer ${nexum_api_key}`,
    'Content-Type': 'application/json'
  }
};

export const fetchMemberData = async () => {
  let member_info;
  try {
     member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
    return member_info;
  }
  catch (error) {
    throw error;
  }
};

export const fetchAddressData = async () => {
    let member_info;
  try {
    member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
    const nexum_body = {
      "Credentials": {
        "AdministrativeCredentials": {
            "Password": nexum_ac
        }
      },
      "Header": {
          "MessageID": "1",
          "RGState": "GETADDRESS"
      },
      "Body": {
          "File": "RHD.SYMX.ADDRESSCHANGE.PND",
          "RGSession": 1,
          "UserDefinedParameters": {
              "RGUserChr": [
                  {
                      "ID": "1",
                      "Value": member_info.member_number.padStart(10,"0")
                  }
              ]
          }
      }
    };
    
    const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
    const response = await axios.post(url, nexum_body, config);
    return JSON.parse(response.data.Body.RGLines);
  } catch (error) {
    console.error("❌ API Request Failed!", error);
    console.error("⚠️ Response Data:", error.response ? error.response.data : "No response data");
    throw error;
  }
};
export const submitAddressData = async ({address,phone,emailSlashPromo,tcpa}) => {
  try {
    const member_info = await getMemberInfo();
    if (!member_info) return null; // Redirect is in progress
    if (member_info.results === 'ERROR'){
      throw new Error(member_info.error);
    }
    const nexum_body = {
      "Credentials": {
        "AdministrativeCredentials": {
            "Password": nexum_ac
        }
      },
      "Header": {
          "MessageID": "1",
          "RGState": "SUBMITADDRESS"
      },
      "Body": {
          "File": "RHD.SYMX.ADDRESSCHANGE.PND",
          "RGSession": 1,
          "UserDefinedParameters": {
              "RGUserChr": [
                  {
                      "ID": "1",
                      "Value": member_info.member_number.padStart(10,"0"),
                  },
                  {
                      "ID": "2",
                      "Value": address,
                  },
                  {
                      "ID": "3",
                      "Value": phone,
                  },
                  {
                      "ID": "4",
                      "Value": emailSlashPromo,
                  },
                  {
                      "ID": "5",
                      "Value": tcpa
                  }
              ]
          }
      }
    };

    const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
    const response = await axios.post(url, nexum_body, config);

    return JSON.parse(response.data.Body.RGLines);
  } catch (error) {
    console.error("❌ API Request Failed!", error);
    console.error("⚠️ Response Data:", error.response ? error.response.data : "No response data");
    throw error;
  }
};

export const confirmAddressData = async ({ streetAddress, secondaryAddress, city, state, zipCode }) => {
  try {
    const accessToken = await getAccessToken();
    let data = JSON.stringify({
      "streetAddress": streetAddress,
      "secondaryAddress": secondaryAddress,
      "city": city,
      "state": state,
      "zipCode": zipCode.slice(0,5),
      "ZIPPlus4": zipCode.slice(6,10)
    });

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/uspsapi/confirm-address',
    headers: { 
      'authorization': accessToken,
      'Ocp-Apim-Subscription-Key': key, 
      'Content-Type': 'application/json'
    },
    data : data
  };
    const response = await axios(config);

    if (response.status === 200) {
      return response.data.address;
    } else {
      console.error("❌ Address validation failed with status:", response.status);
      console.error("Response data:", response.data);
      throw new Error(`Address validation failed: ${response.data?.message || 'Unknown error'}`);
    }
  } catch (error) {
    console.error("❌ API Request Failed!", error);

    if (error.response.status === 500) {
      console.error("⚠️ Invalid Address");
      return "invalid";
    }

    // More specific error handling
    if (error.code === 'ERR_NETWORK') {
      console.error("Network Error Details:");
      console.error("- Check if the API endpoint is accessible");
      console.error("- Verify your network connection");
      console.error("- Check if the API requires CORS configuration");
      throw new Error("Network connection failed. Please check your internet connection and try again.");
    }
    
    if (error.response) {
      console.error("📡 Response data:", error.response.data);
      console.error("📡 Response status:", error.response.status);
      console.error("📡 Response headers:", error.response.headers);
      
      // Handle specific error cases
      if (error.response.status === 401) {
        throw new Error("Authentication failed. Please try again.");
      } else if (error.response.status === 400) {
        throw new Error("Invalid address format. Please check your input.");
      } else if (error.response.status === 404) {
        throw new Error("Address not found. Please verify the address details.");
      } else {
        throw new Error(`Address validation failed: ${error.response.data?.message || 'Unknown error'}`);
      }
    } else if (error.request) {
      console.error("📡 No response received. This could be due to:");
      console.error("📡 Request details:", error.request);
      throw new Error("No response received from the server. Please try again later.");
    } else {
      console.error("📡 Error message:", error.message);
      throw new Error(`Request failed: ${error.message}`);
    }
  } 
};


const getAccessToken = async () => {
  const tokenUrl = 'https://microservices-fd-dtbtaqb0epdrdhf4.a01.azurefd.net/uspsapi/token';

  if (!key) {
    console.error("❌ USPS API Key is not set in environment variables");
    throw new Error("USPS API Key is not configured");
  }

  try {
    
    const requestConfig = {
      method: 'post',
      url: tokenUrl,
      headers: {
        'Ocp-Apim-Subscription-Key': key
      },

      validateStatus: function (status) {
        return status >= 200 && status < 500; // Accept all status codes less than 500
      }
    };
    
    const response = await axios(requestConfig);

    if (response.status === 200) {
      return response.data.access_token;
    } else {
      console.error("❌ Unexpected response status:", response.status);
      console.error("Response data:", response.data);
      throw new Error(`Unexpected response status: ${response.status}`);
    }
  } catch (error) {
    console.error("❌ Failed to retrieve access token:", error);
    if (error.response) {
      console.error("📡 Response data:", error.response.data);
      console.error("📡 Response status:", error.response.status);
      console.error("📡 Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("📡 No response received. This could be due to:");

      
      // Try to provide more specific error information
      if (error.code === 'ERR_NETWORK') {
        console.error("Network error details:");

      }
    } else {
      console.error("📡 Error message:", error.message);
    }
    throw error;
  }
};